import {instance} from "./agent";
import {APIResponseType} from "./types";

export type User = {
    id: number
    username: string
    email: string
    roles: string[]
}
export type VerifyPhone = {
    id: number
    phoneNumber: string
    code: string
}
type LoginResponseType = {
    userId: number
}
let lang = document.cookie.split('; ').find(r => r.startsWith('lang'))?.split('=')[1]

const user = {
    me() {
        return instance.get<APIResponseType<User>>(`account/auth`).then(res => res.data)
    },
    login(email: string, password: string, rememberMe = false, captcha: null | string = null) {
        return instance.post<APIResponseType<LoginResponseType>>(`auth/login`, {email, password, rememberMe, captcha})
            .then(res => res.data);
    },
    logout() {
        return instance.post(`account/logout`).then(res => res.data)
    },
    getOrgByUnp(unp: string) {
        return instance.get<APIResponseType<string>>(`/egr/company/${unp}`).then(res => res.data)
    },
    checkUser(name: string) {
        return instance.get<APIResponseType<boolean>>(`/account/checkUser?name=${name}`).then(res => res.data)
    },
    register(values: any) {
        return instance.post<APIResponseType<number>>(`/account/register`, values).then(res => res.data)
    },
    verifyPhoneNumber(values: VerifyPhone) {
        return instance.post<APIResponseType<boolean>>(`/account/verifyPhoneNumber`, values).then(res => res.data)
    }
}

export default user